import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CustomHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Agregar el encabezado personalizado
    const objetoAlmacenado = localStorage.getItem("usuario");
    if (objetoAlmacenado) {
        // Convertir el objeto de cadena JSON a un objeto JavaScript
        const objetoJavaScript = JSON.parse(objetoAlmacenado);
        const customReq = req.clone({
        setHeaders: {
            'User': objetoJavaScript.nombre
        }
        });
   
    // Pasar la solicitud modificada al siguiente interceptor o al controlador HTTP
    return next.handle(customReq);
  }else{
    return next.handle(req);
  }
}
}
